module.exports = __webpack_public_path__ + "img/img-2@2x.d813adbf.png";